import { render, staticRenderFns } from "./companyCard.vue?vue&type=template&id=0a0b70ac&scoped=true"
import script from "./companyCard.vue?vue&type=script&lang=js"
export * from "./companyCard.vue?vue&type=script&lang=js"
import style0 from "./companyCard.vue?vue&type=style&index=0&id=0a0b70ac&prod&lang=scss&scoped=true"
import style1 from "./companyCard.vue?vue&type=style&index=1&id=0a0b70ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0b70ac",
  null
  
)

export default component.exports